
<div class="p-3">
  <h2 mat-dialog-title>Ha habido un error inesperado</h2>
  <div mat-dialog-content>

    <p>Por favor, vuelve a intentarlo en unos minutos</p>
    <br>
    <h5>Ayúdanos a mejorar y notifica sobre el error al equipo técnico</h5>
    <p>Explícanos qué ha ocurrido</p>
    <textarea class="w-100 form-control" [(ngModel)]="userFeedback"></textarea>

  </div>
  <div mat-dialog-actions class="d-flex justify-content-between mt-3">
    <button class="btn btn-outline-levelab" (click)="close()">Cerrar</button>
    <button class="btn btn-levelab" (click)="sendFeedback()">Enviar comentarios</button>
  </div>
</div>
